<nav class="topbar navbar navbar-expand-lg navbar-light nav-header navbar-fixed">
  <div class="container-fluid nav-container">
    <div class="collapse navbar-collapse" id="navbarSupportedContent" style="margin-left: 278px;">

      <!-- Page Title -->
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 d-flex">
        <li class="nav-item nav-title" style="display: flex; align-items: center;">
          {{ titleService.getTitle() }}
        </li>
      </ul>

      <ul class="navbar-nav mr-auto ms-auto mb-2 mb-lg-0 d-flex">
        <li>
          <span class="name-initials">
            {{nameInitials}}
          </span>
        </li>
        <li class="nav-item menutext">
          <div class="dropdown">
            <button class="btn dropdown-toggle" type="button" (click)="toggleDropdown()">
              {{ user?.name }}
              <img src="/assets/icons/arrow-down.svg" alt="Arrow Down Icon" />
            </button>
            <ul class="dropdown-menu logoutdropdown" [class.show]="isDropdownOpen">
              <li>
                <button class="dropdown-item" (click)="logout()" style="color: #FF5A4F;">
                  <img src="/assets/icons/logout.svg" alt="Logout Icon" />
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </li>
      </ul>

    </div>
  </div>
</nav>